// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'

import Vuex from 'vuex'
import VueResource from 'vue-resource'

import Firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

import infiniteScroll from 'vue-infinite-scroll'

import store from './store'

const config = require('../config/firebase')

Vue.prototype.$firebase = Firebase.initializeApp(config)
Vue.prototype.$firestore = Vue.prototype.$firebase.firestore()
Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(infiniteScroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js